module.exports = __webpack_public_path__ + "img/L10.a2e02d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cooperation/banner/L10.png
// module id = S4EU
// module chunks = 0